import { SVGProps } from 'react';

const Bike = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 17.5V14l-3-3 4-3 2 3h2m5 6.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-13 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M16 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    />
  </svg>
);
export default Bike;
